<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Gestion de Cronogramas</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Nuevo Cronograma</h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-alert color="purple" dark dismissible outlined
            ><strong>Sugerencia:</strong> En el campo Fecha Vigencia Hasta se
            recomienda ingresar una fecha lejana (por ejemplo, 31/12/9999). Este
            campo indica hasta qué fecha será visible el cronograma y, por lo
            general, no se modifica hasta que sea necesario cambiar los horarios
            para ese día de la semana. Si prefiere habilitar las agendas mes a
            mes, no es necesario crear un cronograma nuevo cada mes: simplemente
            limite la fecha de vigencia y extiéndala cuando sea
            necesario.</v-alert
          >
          <v-row dense>
            <v-col cols="12">
              <v-select
                :items="canchas"
                item-text="nombre"
                item-value="idCancha"
                menu-props="auto"
                label="Cancha *"
                hide-details
                prepend-icon="mdi-account"
                v-model="cancha"
                @change="cargarCronogramas"
                no-data-text="No hay canchas configuradas"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <v-select
                :items="dias"
                item-text="nombre"
                item-value="idDia"
                menu-props="auto"
                label="Dia *"
                :rules="requiredRules"
                hide-details
                prepend-icon="mdi-calendar"
                v-model="dia"
              ></v-select>
            </v-col>

            <v-col cols="12" md="4" sm="4">
              <v-menu
                ref="menu"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="horaDesde"
                    label="Hora Desde *"
                    prepend-icon="mdi-clock"
                    readonly
                    :rules="requiredRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu2"
                  v-model="horaDesde"
                  format="24hs"
                  full-width
                  scrollable
                  @click:minute="$refs.menu.save(horaDesde)"
                ></v-time-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" md="4" sm="4">
              <v-menu
                ref="menu2"
                v-model="menu3"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="horaHasta"
                    label="Hora Hasta *"
                    prepend-icon="mdi-clock"
                    readonly
                    :rules="requiredRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="menu3"
                  v-model="horaHasta"
                  full-width
                  scrollable
                  format="24hs"
                  @click:minute="$refs.menu2.save(horaHasta)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="fechaDesde"
                :value="fechaDesde"
                label="Fecha Vigencia Desde *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="fechaHasta"
                :value="fechaHasta"
                :rules="requiredRules"
                label="Fecha Vigencia Hasta *"
                prepend-icon="mdi-calendar"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <v-select
                :items="tiemposTurnos"
                item-text="tiempoNombre"
                item-value="idTiempoTurno"
                :rules="requiredRules"
                menu-props="auto"
                label="Tiempo del Turno *"
                hide-details
                prepend-icon="mdi-clock"
                v-model="tiempoTurno"
              ></v-select>
            </v-col>
            <v-col cols="8" md="3" sm="4">
              <v-switch
                dense
                v-model="disponibleWeb"
                label="Disponible en Web"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="guardarCronograma"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-form>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-chip label color="transparent" text-color="black" class="ma-0">
              <h3>Lista de cronogramas creados para la cancha</h3>
            </v-chip>
          </v-col>

          <v-col cols="12">
            <v-checkbox
              v-model="soloVigentes"
              label="Mostrar en la grilla solo cronogramas vigentes"
              color="primary"
              dense
              @change="cargarCronogramas"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-data-table
          v-if="listaCronogramas.length"
          :headers="headers"
          :items="this.listaCronogramas"
          class="elevation-1"
          :hide-default-footer="true"
          locale="es-ar"
          item-key="idCronograma"
          :items-per-page="500"
          :custom-sort="sortDates"
        >
          <template v-slot:item.disponibleWeb="{ item }">
            <v-simple-checkbox
              v-model="item.disponibleWeb"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.alternaSemana="{ item }">
            <v-simple-checkbox
              v-model="item.alternaSemana"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="purple"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="editarCronograma(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar Cronograma</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="orange"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="verUsuarios(item)"
                  >mdi-account-multiple-check-outline</v-icon
                >
              </template>
              <span>Creado por / Modificado por</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  color="red"
                  v-bind="attrs"
                  @click="borrarCronograma(item)"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Eliminar Cronograma</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-alert class="mt-4" color="purple" dark outlined v-else>
          No hay cronogramas
          {{ soloVigentes ? "vigentes" : "" }} configurados para la cancha.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn dark color="#24232d" @click="salir">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="indigo"
          dark
          @click="
            $router.push({
              name: 'gestionTurnos',
              params: { idCancha: cancha },
            })
          "
          >agenda diaria</v-btn
        >
        <v-btn
          color="warning"
          @click="
            $router.push({
              name: isMobile()
                ? 'gestionTurnosSemana'
                : 'gestionTurnosSemanaWide',
              params: { idCancha: cancha },
            })
          "
          >agenda semanal</v-btn
        >
      </v-card-actions>
      <EditarCronograma
        :visible="showEditarCronograma"
        :idCronograma="editedItem.idCronograma"
        :idProfesional="cancha"
        @close="showEditarCronograma = false"
        @cronogramaModificado="cronogramaModificado"
      ></EditarCronograma>
      <VerUsuarios
        :visible="showVerUsuarios"
        :cronograma="editedItem"
        @close="showVerUsuarios = false"
      ></VerUsuarios>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
.container {
  margin: auto;
}
</style>
<script>
import axios from "@/axios-auth";
import router from "@/router";
import EditarCronograma from "./EditarCronograma.vue";
import VerUsuarios from "./VerUsuarios.vue";
import { isMobile } from "@/utils/utils";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    cancha: "",
    canchas: [],
    listaCronogramas: [],
    guardandoCronograma: false,
    headers: [
      { text: "Fecha Alta", value: "soloFechaAltaString" },
      { text: "Dia", value: "nombreDia" },
      { text: "Hora Desde", value: "horaInicioString" },
      { text: "Hora Hasta", value: "horaFinString" },
      { text: "Vigencia Desde", value: "fechaInicioString" },
      { text: "Vigencia Hasta", value: "fechaFinString" },
      { text: "Tiempo Turno", value: "tiempoTurnoNombre" },
      { text: "Disponible Web", value: "disponibleWeb" },
      { text: "Acciones", value: "actions" },
    ],
    tipoTurnos: [
      { value: 0, text: "Presencial" },
      { value: 1, text: "Videoconsulta" },
      {
        value: 2,
        text: "Turno Web: Elige Paciente - Turno Interno: Presencial",
      },
      {
        value: 3,
        text: "Turno Web: Elige Paciente - Turno Interno: Videconsulta",
      },
    ],
    tipoTurno: 0,
    soloVigentes: true,
    menu2: false,
    menu3: false,
    modal2: false,
    modal3: false,
    horaDesde: null,
    horaHasta: null,
    fechaDesde: null,
    fechaHasta: null,
    menu: false,
    dia: "",
    dias: [],
    tiempoTurno: "",
    tiemposTurnos: [],
    disponibleWeb: false,
    time: null,
    editedItem: {},
    editedIndex: -1,
    showEditarCronograma: false,
    showVerUsuarios: false,
    alternaSemana: false,
  }),
  created() {
    this.canchas = this.$store.state.usuario.canchas.sort((a, b) =>
      a.nombre.localeCompare(b.nombre),
    );
    console.log("state", this.$store.state.usuario.canchas);
    if (this.$route.params.idCancha) {
      this.cancha = this.$route.params.idCancha;
    } else {
      this.cancha = this.canchas[0].idCancha;
    }
    this.cargarDias();
    this.cargarTiemposTurnos();
    this.soloVigentes = true;
    this.cargarCronogramas();
  },
  mounted() {
    document.getElementsByClassName("container")[0].scrollTop = 0;
  },
  computed: {
    tipoTurnoLabel() {
      return "Tipo Turno Predeterminado";
    },
  },
  methods: {
    isMobile,
    sortDates(items, sortBy, sortDesc) {
      const key = sortBy[0];
      const desc = sortDesc[0];

      // Si NO es la columna de fecha → sort normal
      if (key !== "soloFechaAltaString") {
        return items.sort((a, b) => {
          const sortA = a[key];
          const sortB = b[key];
          return (sortA < sortB ? -1 : 1) * (desc ? -1 : 1);
        });
      }

      return items.sort((a, b) => {
        const dateA = this.parseArgDate(a.soloFechaAltaString);
        const dateB = this.parseArgDate(b.soloFechaAltaString);

        // ----- Manejo de strings vacíos -----

        // ambos vacíos → iguales
        if (!dateA && !dateB) return 0;

        // solo A vacío
        if (!dateA) return desc ? 1 : -1;

        // solo B vacío
        if (!dateB) return desc ? -1 : 1;

        // ----- Comparación normal de fechas -----
        return (dateA - dateB) * (desc ? -1 : 1);
      });
    },
    parseArgDate(str) {
      if (!str) return null;
      // "14/08/2025" → Date(2025, 07, 14)
      const [day, month, year] = str.split("/").map(Number);
      return new Date(year, month - 1, day);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    verUsuarios(item) {
      this.editedIndex = this.listaCronogramas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showVerUsuarios = true;
    },
    cargarCronogramas() {
      const datosCronograma = {
        soloVigentes: this.soloVigentes,
        idProfesional: this.cancha,
      };
      let self = this;
      axios
        .get("/Turnos/ConsultarCronogramas?", {
          params: {
            soloVigentes: datosCronograma.soloVigentes,
            idProfesional: datosCronograma.idProfesional,
          },
        })
        .then((response) => {
          if (response.data != null && response.data != "")
            self.listaCronogramas = response.data;
          else self.listaCronogramas = [];
        })
        .catch((error) => {});
    },
    editarCronograma(item) {
      this.editedIndex = this.listaCronogramas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEditarCronograma = true;
    },
    cargarDias() {
      let self = this;
      axios
        .get("/Turnos/GetDias")
        .then((response) => {
          self.dias = response.data;
        })
        .catch((error) => {});
    },
    cargarTiemposTurnos() {
      let self = this;
      axios
        .get("/Turnos/GetTiemposTurnos")
        .then((response) => {
          self.tiemposTurnos = response.data;
        })
        .catch((error) => {});
    },
    salir() {
      router.push({ path: "/Home" });
    },
    validarFecha(fecha) {
      if (fecha.toString().length > 10) return false;
      else return true;
    },
    guardarCronograma() {
      this.$swal({
        title: "Guardar Cronograma",
        text: "¿Desea registrar el cronograma?",
        icon: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          let isValidDate = this.validarFecha(this.fechaDesde);
          if (!isValidDate) {
            this.showAlert({
              icon: "warning",
              title: "La fecha desde no tiene un formato válido.",
              vm: this,
              timer: 2000,
            });
            return;
          }
          isValidDate = this.validarFecha(this.fechaHasta);
          if (!isValidDate) {
            this.showAlert({
              icon: "warning",
              title: "La fecha hasta no tiene un formato válido.",
              vm: this,
              timer: 2000,
            });
            return;
          }

          let self = this;
          const datosCronograma = {
            idProfesional: this.cancha,
            idDia: this.dia,
            idTiempoTurno: this.tiempoTurno,
            disponibleWeb: this.disponibleWeb,
            fechaInicio: this.fechaDesde,
            fechaFin: this.fechaHasta,
            horaInicioCompleta: this.horaDesde
              .replace(":", "")
              .trim()
              .replace(" ", ""),
            horaFinCompleta: this.horaHasta
              .replace(":", "")
              .trim()
              .replace(" ", ""),
            horaInicio: this.horaDesde
              .replace(":", "")
              .trim()
              .replace(" ", "")
              .substring(0, 2)
              .replace(" ", ""),
            horaFin: this.horaHasta
              .replace(":", "")
              .trim()
              .replace(" ", "")
              .substring(0, 2)
              .replace(" ", ""),
            minutoInicio: this.horaDesde
              .replace(":", "")
              .trim()
              .replace(" ", "")
              .substring(2, 4)
              .replace(" ", ""),
            minutoFin: this.horaHasta
              .replace(":", "")
              .trim()
              .replace(" ", "")
              .substring(2, 4)
              .replace(" ", ""),
          };
          if (
            datosCronograma.horaInicioCompleta > datosCronograma.horaFinCompleta
          ) {
            self.showAlert({
              icon: "warning",
              title: "La hora desde no puede ser mayor que la hora hasta",
              vm: this,
              timer: 2000,
            });
            return;
          }
          if (datosCronograma.fechaInicio > datosCronograma.fechaFin) {
            self.showAlert({
              icon: "warning",
              title: "La fecha desde no puede ser mayor que la fecha hasta",
              vm: this,
              timer: 2000,
            });
            return;
          }
          this.grabarCronograma();
        }
      });
    },
    grabarCronograma() {
      let self = this;
      if (this.guardandoCronograma) {
        return;
      }
      this.guardandoCronograma = true;
      const tipoTurno = this.tipoTurno;
      const datosCronograma = {
        idProfesional: this.cancha,
        idDia: this.dia,
        idTiempoTurno: this.tiempoTurno,
        fechaInicio: this.fechaDesde,
        fechaFin: this.fechaHasta,
        disponibleWeb: this.disponibleWeb,
        fechaInicioString: this.fechaDesde,
        fechaFinString: this.fechaHasta,
        horaInicioCompleta: this.horaDesde
          .replace(":", "")
          .trim()
          .replace(" ", ""),
        horaFinCompleta: this.horaHasta
          .replace(":", "")
          .trim()
          .replace(" ", ""),
        horaInicio: this.horaDesde
          .replace(":", "")
          .trim()
          .replace(" ", "")
          .substring(0, 2)
          .replace(" ", ""),
        horaFin: this.horaHasta
          .replace(":", "")
          .trim()
          .replace(" ", "")
          .substring(0, 2)
          .replace(" ", ""),
        minutoInicio: this.horaDesde
          .replace(":", "")
          .trim()
          .replace(" ", "")
          .substring(2, 4)
          .replace(" ", ""),
        minutoFin: this.horaHasta
          .replace(":", "")
          .trim()
          .replace(" ", "")
          .substring(2, 4)
          .replace(" ", ""),
        tipoTurno: tipoTurno,
        usuarioAlta: this.$store.state.usuario.usuario,
        alternaSemana: this.alternaSemana,
        idClienteCrm: this.$store.state.usuario.institucion.idClienteCrm ?? "",
      };
      axios
        .post("/Turnos/GuardarCronograma", datosCronograma)
        .then((response) => {
          self.$refs.form.resetValidation();

          self.showAlert({
            icon: "success",
            title: "Cronograma Registrado",
            vm: self,
            timer: 2000,
          });
          self.cargarCronogramas();
        })
        .catch((error) => {
          self.showAlert({
            icon: "warning",
            title:
              error.response.data.error ||
              error.response?.data?.message ||
              error.message,
            vm: this,
            timer: 2000,
          });
        })
        .finally(() => {
          self.guardandoCronograma = false;
        });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    borrarCronograma(item) {
      this.$swal({
        title: "Borrar Cronograma",
        text: "¿Desea borrar el cronograma?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const idCronograma = item.idCronograma;
          const datosCronograma = {
            idProfesional: this.cancha,
            idDia: item.idDia,
            idTiempoTurno: item.idTiempoTurno,
            disponibleWeb: item.disponibleWeb,
            fechaInicioString: item.fechaInicioString,
            fechaFinString: item.fechaFinString,
            horaInicioCompleta: item.horaInicioString
              .replace(":", "")
              .trim()
              .replace(" ", ""),
            horaFinCompleta: item.horaFinString
              .replace(":", "")
              .trim()
              .replace(" ", ""),
          };
          let self = this;
          axios
            .get("/Turnos/ChequearExistenciaTurnosCronograma", {
              params: {
                idCancha: datosCronograma.idProfesional,
                idDia: datosCronograma.idDia,
                fechaInicio: datosCronograma.fechaInicioString,
                fechaFin: datosCronograma.fechaFinString,
                horaInicioCompleta: datosCronograma.horaInicioCompleta,
                horaFinCompleta: datosCronograma.horaFinCompleta,
              },
            })
            .then((response) => {
              if (response.data != "") {
                self.showAlert({
                  icon: "warning",
                  title:
                    "Hay turnos que caen dentro del cronograma que quiere borrar",
                  vm: this,
                  timer: 2000,
                });
              } else {
                axios
                  .get("/Turnos/BorrarCronograma?", {
                    params: {
                      idCronograma: idCronograma,
                    },
                  })
                  .then((response) => {
                    self.showAlert({
                      icon: "success",
                      title: "Cronograma borrado",
                      vm: self,
                      timer: 2000,
                    });
                    setTimeout(self.cargarCronogramas(), 1700);
                  })
                  .catch((error) => {
                    self.showAlert({
                      icon: "warning",
                      title: "El cronograma no pudo ser borrado",
                      vm: this,
                      timer: 2000,
                    });
                  });
              }
            });
        }
      });
    },
    cronogramaModificado() {
      this.cargarCronogramas();
      setTimeout(this.cerrarVentanaModificar, 600);
    },
    cerrarVentanaModificar() {
      this.showEditarCronograma = false;
    },
  },
  components: {
    EditarCronograma,
    VerUsuarios,
  },
};
</script>
